import { useEffect, useState } from 'react';
import { onSessionExpired } from '../services/refreshService';

export const useSessionExpiration = () => {
    const [isSessionExpired, setIsSessionExpired] = useState(false);
    // One renewal timer belongs to AuthProvider, not to each protected page.
    useEffect(() => onSessionExpired(() => setIsSessionExpired(true)), []);
    return { isSessionExpired, setIsSessionExpired };
};
